var i18nLib = require("../i18n");

exports.getGuestOrdinal = getGuestOrdinal;
exports.getUrlParameter = getUrlParameter;
exports.addQSParm = addQSParm;
exports.forceArray = forceArray;
exports.debounce = debounce;
exports.isInputKey = isInputKey;
exports.isMobile = isMobile;
exports.clearUrlQuery = clearUrlQuery;
exports.clearUrlAnchor = clearUrlAnchor;
exports.assureAnchorClick = assureAnchorClick;
exports.trySequentially = trySequentially;

function getGuestOrdinal (n) {
	var numbers = ["", "First", "Second", "Third", "Fourth", "Fifth", "Sixth", "Seventh", "Eighth", "Nineth", "Tenth", "Eleventh", "Twelfth", "Thirteenth", "Fourteenth", "Fifteenth", "Sixteenth", "Seventeenth", "Eighteenth", "Nineteenth", "Twentieth", "Twenty-first", "Twenty-second", "Twenty-third", "Twenty-fourth", "Twenty-fifth", "Twenty-sixth", "Twenty-seventh", "Twenty-eighth", "Twenty-nineth", "Thirty"]

	return i18nLib.localize(numbers[n]);
}

function getUrlParameter (sParam) {
	var sPageURL = decodeURIComponent(window.location.search.substring(1)),
		sURLVariables = sPageURL.split('&'),
		sParameterName,
		i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : sParameterName[1];
		}
	}
};

function addQSParm (myUrl, name, value) {
	var re = new RegExp("([?&]" + name + "=)[^&]+", "");

	function add (sep) {
		myUrl += sep + name + "=" + encodeURIComponent(value);
	}

	function change () {
		myUrl = myUrl.replace(re, "$1" + encodeURIComponent(value));
	}
	if (myUrl.indexOf("?") === -1) {
		add("?");
	} else {
		if (re.test(myUrl)) {
			change();
		} else {
			add("&");
		}
	}
	return myUrl;
}

function forceArray (data) {
	if (!Array.isArray(data)) {
		if (data !== null && data !== undefined) {
			data = [data];
		} else {
			data = [];
		}
	}
	return data;
}

function debounce (func, wait, immediate) {
	var timeout;
	return function () {
		var context = this, args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

function isInputKey (whichCode) {
	if (whichCode == 20 /* Caps lock */
		|| whichCode == 16 /* Shift */
		|| whichCode == 9 /* Tab */
		|| whichCode == 27 /* Escape Key */
		|| whichCode == 17 /* Control Key */
		|| whichCode == 91 /* Windows Command Key */
		|| whichCode == 19 /* Pause Break */
		|| whichCode == 18 /* Alt Key */
		|| whichCode == 93 /* Right Click Point Key */
		|| (whichCode >= 35 && whichCode <= 40) /* Home, End, Arrow Keys */
		|| whichCode == 45 /* Insert Key */
		|| (whichCode >= 33 && whichCode <= 34) /*Page Down, Page Up */
		|| (whichCode >= 112 && whichCode <= 123) /* F1 - F12 */
		|| (whichCode >= 144 && whichCode <= 145)) { /* Num Lock, Scroll Lock */
		return false;
	}
	return true;
}

function isMobile () {
	return (window.matchMedia && window.matchMedia('screen and (max-width: 992px)').matches) || Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 992 || navigator.userAgent.indexOf('IEMobile') !== -1;
}

function clearUrlQuery (url) {
	var resultUrl = String(url || '');
	return resultUrl.split(/\/\?|\?/g)[0] || resultUrl;
}

function clearUrlAnchor (url) {
	var resultUrl = String(url || '');
	return resultUrl.split(/\/#|#/g)[0] || resultUrl;
}

function assureAnchorClick (targetElement, url) {
	var anchor = targetElement instanceof jQuery ? targetElement : $(targetElement);
	anchor.off('mousedown');
	// Make sure that link is clicked before blur event
	if (url) {
		anchor.mousedown(function () {
			if (clearUrlAnchor(location.href) !== clearUrlAnchor($(this).prop('href'))) {
				location.href = clearUrlAnchor($(this).prop('href')) || '#';
			}
		});
	}
}

function required (value, label, msg) {
	if (value === null || value === undefined) {
		label = label || '';
		throw new Error(msg ? msg.replace('${label}', label) : `REQUIRED: ${label}`);
	}
	return value;
}

function trySequentially (namedParameters) {
	var arraySlice = Array.prototype.slice;
	var thisArg = namedParameters.thisArg;
	var callbackParams = arraySlice.call(namedParameters.callbackParams || []);
	var callback = required(typeof namedParameters.callback === 'function' ? namedParameters.callback : null, 'callback');
	var nTimes = required(parseInt(namedParameters.nTimes) > 0 ? parseInt(namedParameters.nTimes) : null, 'nTimes') - 1;
	var call = function () {
		var dfd = $.Deferred();
		var success = function () {
			dfd.resolve(callbackParams);
		};
		var failure = function () {
			dfd.reject(callbackParams);
		};
		callbackParams.unshift(success, failure);
		callback.apply(thisArg, callbackParams);

		return dfd.promise();
	};

	var i = 1;
	var lastPromise = call();
	var stopOnSuccess = function () { };
	var promiseExec = function () {
		if (i++ <= nTimes) {
			lastPromise = call();
			lastPromise.then(stopOnSuccess, promiseExec);
		}
	};
	return lastPromise.then(stopOnSuccess, promiseExec);
}



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/__aux.js